var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwnerWalletBannerbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 153,
    viewBox: "0 0 310 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 271.601,
    y: 35.675,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 271.601 35.675)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 271.601,
    y: 113.325,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 271.601 113.325)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 193.95,
    y: 35.675,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 193.95 35.675)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.301,
    y: 35.675,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 116.301 35.675)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6504,
    y: 35.675,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 38.6504 35.675)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 193.95,
    y: 113.325,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 193.95 113.325)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 116.301,
    y: 113.325,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 116.301 113.325)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6504,
    y: 113.325,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 38.6504 113.325)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 271.601,
    y: 74.5,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 271.601 74.5)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 271.601,
    y: 152.15,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 271.601 152.15)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 193.95,
    y: 74.5,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 193.95 74.5)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 116.301,
    y: 74.5,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 116.301 74.5)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6504,
    y: 74.5,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 38.6504 74.5)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 193.95,
    y: 152.15,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 193.95 152.15)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 116.301,
    y: 152.15,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 116.301 152.15)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6504,
    y: 152.15,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 38.6504 152.15)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 310.426,
    y: 35.675,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 310.426 35.675)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 310.426,
    y: 113.325,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 310.426 113.325)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 232.776,
    y: 35.675,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 232.776 35.675)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 232.776,
    y: 113.325,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 232.776 113.325)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 155.125,
    y: 35.675,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 155.125 35.675)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4756,
    y: 35.675,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 77.4756 35.675)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 155.125,
    y: 113.325,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 155.125 113.325)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4756,
    y: 113.325,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 77.4756 113.325)",
    fill: "white",
    fillOpacity: 0.02
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 310.426,
    y: 74.5,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 310.426 74.5)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 310.426,
    y: 152.15,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 310.426 152.15)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 232.776,
    y: 74.5,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 232.776 74.5)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 232.776,
    y: 152.15,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 232.776 152.15)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 155.125,
    y: 74.5,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 155.125 74.5)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4756,
    y: 74.5,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 77.4756 74.5)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 155.125,
    y: 152.15,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 155.125 152.15)",
    fill: "black",
    fillOpacity: 0.02
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 77.4756,
    y: 152.15,
    width: 38.8252,
    height: 38.8252,
    transform: "rotate(-180 77.4756 152.15)",
    fill: "black",
    fillOpacity: 0.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwnerWalletBannerbg);
export default __webpack_public_path__ + "static/media/owner_wallet_bannerbg.67b1e08ca843e7d89ce5f236812e234a.svg";
export { ForwardRef as ReactComponent };